module.exports = __webpack_public_path__ + "static/media/test21_2.0dffdcc9.png";